import {EngagementTemplate, UpsertEngagementTemplate} from "platformed-client/types";
import {platformedClient} from "..";
import {invalidateQueries, q} from "../../state";

export async function list(): Promise<EngagementTemplate[]> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/engagement_templates", {});
}

export async function replaceAll(templates: UpsertEngagementTemplate[]): Promise<void> {
  await platformedClient.internalRequest("put", "/region/{region}/api/tprm/engagement_templates", {body: templates});

  await invalidateQueries([q.tprm.engagementTemplates.filter()]);
}
